const { keys, forEach, find } = require('lodash');
export const urlFromClientData = (profileUrl, clientData) => {
    const requiredKeys = ['birthday', 'cellphone', 'email', 'firstName', 'lastName', 'nam', 'unknownMother', 'motherFirstName', 'motherLastName', 'unknownFather', 'fatherFirstName', 'fatherLastName', 'gender', 'baseUrl', 'locale', 'appointmentLocale'];
    const url = new URL(profileUrl + '/auth/register');
    forEach(keys(clientData), (key) => {
        if (!find(requiredKeys, (it) => it === key)) {
            return;
        }
        if (key.includes('unknown')) {
            url.searchParams.append(key.replace('unknown', '').toLowerCase() + 'Unknown', clientData[key]);
            return;
        }
        url.searchParams.append(key, clientData[key]);
    });
    return url.href;
};
